import { useBlockProps } from "./useBlockProps.js";
import { useDiscriminatedData } from "../discrimination/useDiscriminatedData.js";
const useNormalizedBlocks = (children) => {
  const propList = useBlockProps(children);
  return useDiscriminatedData(propList);
};
export {
  useNormalizedBlocks
};
//# sourceMappingURL=useNormalizedBlocks.js.map
